import { FlatQuotationLine } from '@ravago/shared/page-data/models/elements';

import { CombinedResolution, CombinedSuggestion } from './combined-pricing.utils';

export interface QuoteSelectionMeta {
   selectedLineId: string | undefined;
   selectedQuantity: number | undefined;
   selectedLinePackaging: string | undefined;
   isQuantityValid: boolean;
}

export const getSuggestionRows = (resolution: CombinedResolution): CombinedSuggestion[] => {
   if (resolution.kind === 'quote') {
      if (resolution.matchingLines.length <= 1) return [];
      return resolution.matchingLines.map((line) => ({ kind: 'quote', quantity: resolution.quantity, line }));
   }

   if (resolution.kind === 'suggestion') {
      return resolution.suggestions;
   }

   return [];
};

export const getQuoteSelectionMeta = (resolution: CombinedResolution): QuoteSelectionMeta => {
   if (resolution.kind !== 'quote') {
      return {
         selectedLineId: undefined,
         selectedQuantity: undefined,
         selectedLinePackaging: undefined,
         isQuantityValid: false
      };
   }

   return {
      selectedLineId: resolution.line.lineId,
      selectedQuantity: resolution.quantity,
      selectedLinePackaging: resolution.line.linePackaging,
      isQuantityValid: true
   };
};

/** Unit of measure for the quantity input: the quote lines' own UOM unless an override is given. */
export const getQuantityUnitOfMeasure = (quoteLines: FlatQuotationLine[], unitOfMeasureOverride?: string): string => {
   return unitOfMeasureOverride ?? quoteLines[0]?.lineQuantityUOM ?? 'kg';
};

/** True when any line carries a bracket range, i.e. rows represent quantity ranges rather than exact quantities. */
export const hasBracketRanges = (quoteLines: FlatQuotationLine[]): boolean =>
   quoteLines.some((line) => line.lineQuantityToAmount !== undefined && line.lineQuantityToAmount > line.lineQuantityAmount);
